import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { FaTimes, FaPlus } from 'react-icons/fa';

import StyledTappable from '../../components/common/StyledTappable';
import Modal from '../common/Modal';
import { FlyInTransition } from '../../components/transitions/transitions';

import profileIcon from '../../images/lab-test/profile.svg';
import checkedIcon from '../../images/pharmacy/checked.svg';
import UnderLineIcon from '../../images/lab-test/underline.svg';
import OfferTagIcon from '../../images/lab-test/offer-tag.svg';
import {
  getPatients,
  getAhcPartners,
  submitAhcReimbursementRequest,
  getLabTestsCart,
  addMcdermottAhcToCart,
  selectPatient as selectPatientService,
  getAddress,
  getLabSlots,
  saveNewPatient as saveNewPatientService,
  getPackageLeadsDetails,
  removeLabTestRecommended,
} from '../../services';
import LoadingComponent from '../../components/common/LoadingComponent';
import HeaderImage from '../../images/upsell/man-giving-thumbs-up-with-gray-background 1.svg';
import Header from '../../components/common/Header';
import Prize from '../../images/upsell/Prize.svg';
import Tat from '../../images/upsell/tat.svg';
import BookedRecently from '../../images/upsell/booked-recently.svg';
import FooterButton from '../../components/common/FooterButton';
import UpsellBookingFlowModals from './UpsellBookingFlowModals';
import dismissNativeWebViewOrNavigateHome from '../../utils/dismissNativeWebViewOrNavigateHome';
import { logEvent } from '../../utils/logEvent';

const InfoSection = [
  { id: 1, image: Tat, text: 'Reports in 24  hours' },
  { id: 2, image: BookedRecently, text: '100k+ Booked Recently' },
];

const SideImageContainer = styled.img`
  -webkit-mask-image: linear-gradient(
    172.25deg,
    #ffffff 44.8%,
    rgba(255, 255, 255, 0) 87.58%
  );
  mask-image: linear-gradient(
    172.25deg,
    #ffffff 44.8%,
    rgba(255, 255, 255, 0) 95%
  );
  height: 182px;
  width: 227px;
`;

const PackageName = styled.div`
  color: #5840bb;
  font-weight: 800;
  font-size: 24px;
`;

const CloseContainer = styled(StyledTappable)`
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 8px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AddTextIcon = styled(FaPlus)`
  color: #714fff;
  height: 10px;
  width: 10px;
`;

const CloseIcon = styled(FaTimes)`
  color: #413958;
`;

const DiscountPill = styled.div`
  background: linear-gradient(180deg, #ff857a 0%, #ff626f 100%);
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 107%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fff;
  border-radius: 10px;
  padding: 4px 8px;
`;

const Select = styled.select`
  width: 100%;
  height: 36px;
  border: 1px solid #6544c6;
  box-sizing: border-box;
  border-radius: 8px;
  padding-left: 15px;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 15px;
  color: #242327;
`;

const Option = styled.option`
  height: 24px;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #242327;
`;

const Label = styled.label`
  top: calc(50% - 12px / 2 - 134.5px);
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 12px;
  color: #4e4c54;
  margin: 15px 6px 5px 0px;
`;

const AHCHead2 = styled.div`
  background: linear-gradient(
    150.49deg,
    #fbe3c6 6.77%,
    #fff5ea 40.51%,
    #ffffff 78.87%
  );
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 12px 12px 0 0;
`;

const getInitialDateState = () => {
  const today = new Date();
  const minimumStartDate = new Date(2021, 2, 8);
  if (today.valueOf() < minimumStartDate.valueOf()) {
    return { selectedDate: minimumStartDate, minimumStartDate };
  }
  const selectedDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 2
  );
  if (selectedDate.getDay() === 0) {
    selectedDate.setDate(selectedDate.getDate() + 1);
  }
  return {
    selectedDate,
    minimumStartDate: new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 2
    ),
  };
};

const PackageDetails = ({ authToken, location }) => {
  const history = useHistory();
  const bookingFlowRef = useRef(null);

  const searchParams = new URLSearchParams(location.search);
  const initialShowCloseButton =
    searchParams.get('showCloseButton') !== 'false';
  const navState = location?.state || {};
  const packageIdFromNavOrQuery =
    navState?.packageId ?? searchParams.get('packageId') ?? null;
  const cartIdFromNavOrQuery =
    navState?.cartId ?? searchParams.get('cartId') ?? null;
  const addedCartItemFromNavOrQuery =
    navState?.addedCartItem ?? searchParams.get('addedCartItem') ?? null;
  const autoBookFromNavOrQuery =
    navState?.autoBook ?? searchParams.get('autoBook') === 'true';

  const [loading, setLoading] = useState(true);
  const [packageDetails, setPackageDetails] = useState([]);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showPatientModal, setShowPatientModal] = useState(false);
  const [showPatients, setShowPatients] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showAddress, setShowAddress] = useState(false);
  const [showSlotsModal, setShowSlotsModal] = useState(false);
  const [showSlots, setShowSlots] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showDateModalTransition, setShowDateModalTransition] = useState(false);
  const [showPartnerListModal, setShowPartnerListModal] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showInvoiceModalTransition, setShowInvoiceModalTransition] =
    useState(false);
  const [showTestTypeModal, setShowTestTypeModal] = useState(false);
  const [showCloseButton] = useState(initialShowCloseButton);
  const [partnerListLoaded, setPartnerListLoaded] = useState(false);
  const [partners, setPartners] = useState([]);
  const [patients, setPatients] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [slots, setSlots] = useState([]);
  const [showAddPatientButton, setShowAddPatientButton] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const [booking, setBooking] = useState(false);
  const [reimbursementProcess, setReimbursementProcess] = useState(false);
  const [invoiceFiles, setInvoiceFiles] = useState([]);
  const [addNewPatientModal, setAddNewPatientModal] = useState(false);
  const [userName, setUserName] = useState('');
  const [userAge, setUserAge] = useState('');
  const [userContact, setUserContact] = useState('');
  const [userGender, setUserGender] = useState('');
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [cartId, setCartId] = useState(cartIdFromNavOrQuery || null);

  const nodeRef = useRef(null);
  const bookCashlessAhcRef = useRef(false);

  const loadingRef = useRef(loading);
  const cartIdRef = useRef(cartId);
  const addedCartItemRef = useRef(addedCartItemFromNavOrQuery);

  useEffect(() => {
    logEvent('AHC Package Detail Page Viewed', {
      type: 'upsell',
    });
  }, []);

  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);
  useEffect(() => {
    cartIdRef.current = cartId;
  }, [cartId]);
  useEffect(() => {
    addedCartItemRef.current = addedCartItemFromNavOrQuery;
  }, [addedCartItemFromNavOrQuery]);

  const upsellModalOpenRef = useRef(false);
  useEffect(() => {
    upsellModalOpenRef.current =
      showPatientModal ||
      showPatients ||
      addNewPatientModal ||
      showMessageModal ||
      showInvoiceModal;
  }, [
    showPatientModal,
    showPatients,
    addNewPatientModal,
    showMessageModal,
    showInvoiceModal,
  ]);

  useEffect(() => {
    if (!showPatients && showPatientModal) {
      const timer = setTimeout(() => {
        setShowPatientModal(false);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [showPatients, showPatientModal]);

  const requestAhc = () => {
    setShowPatientModal(false);
    setShowPatients(false);
  };

  const fetchPatients = (id) => {
    getPatients(authToken, null, id)
      .then((res) => {
        setPatients(res.patients);
        setShowAddPatientButton(res.enableAddPatient);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOutsideClick = (e) => {
    if (nodeRef.current && nodeRef.current.contains(e.target)) {
      return;
    }
    closeModal();
  };

  const handleSelectPatient = (ele) => {
    setLoading(true);
    if (ele) {
      setSelectedPatient(ele);
      setShowPatientModal(false);
      setShowPatients(false);
      addMcdermottAhcToCart(
        cartId,
        packageDetails.packageId,
        packageDetails.testType
      )
        .then(() => {
          setLoading(false);
          return selectPatientService(cartId, ele.patientId, authToken);
        })
        .then(() => {
          if (typeof window.Android !== 'undefined') {
            return window.Android.openCartDetailsLab(
              packageDetails.testType,
              cartId
            );
          } else if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                method: 'openCartDetailsLab',
                cartId,
                testsType: packageDetails.testType,
              })
            );
          } else {
            history.push('/lab-test/review-cart', { cartId });
          }
        });
    }
  };

  const startUpsellBookingFlow = () => {
    if (!cartId) return;
    bookingFlowRef.current?.start({
      cartId,
      packageId: packageIdFromNavOrQuery,
      visitType: 'home',
      bookingFor: 'AHC',
      onComplete: ({ cartId: cId, patient, selectedSlot }) => {
        history.push('/ahc-upsell/order-summary', {
          cartId: cId,
          from: 'package-details',
          patient,
          selectedSlot,
        });
      },
    });
  };

  const hideModal = () => {
    setShowPatients(false);
    setShowPartnerListModal(false);
    setShowDateModalTransition(false);
    setShowInvoiceModal(false);
    setShowInvoiceModalTransition(false);
    setAddNewPatientModal(false);
    setUserName(null);
    setUserAge(null);
    setUserContact(null);
    setUserGender(null);
  };

  const closeModal = () => {
    hideModal();
    setSelectedPatient(null);
    setPartnerListLoaded(false);
    setPartners([]);
    setInvoiceFiles([]);
    setShowDateModal(false);
    setReimbursementProcess(false);
    setShowTestTypeModal(false);
  };

  const hideMessageModal = () => {
    console.log('hide message modal');
    setShowMessageModal(false);
  };

  const raiseReimbursementRequest = () => {
    setReimbursementProcess(true);
    requestAhc();
  };

  const handleAttachment = (type) => {
    let inputElem = document.getElementById('fileAttachment');
    if (type === 'photo') {
      inputElem = document.getElementById('photoAttachment');
    }
    const file = inputElem.files[0];
    if (!file) return;
    const data = Array.from(invoiceFiles);
    data.push(file);
    setInvoiceFiles(data);
    document.getElementById('photoAttachment').files = null;
  };

  const addAhcReimbursementRequest = () => {
    setBooking(true);
    const data = new FormData();
    invoiceFiles.forEach((file) => {
      data.append('file', file);
    });
    data.append('patientId', selectedPatient);

    const onUploadProgress = (progressEvent) => {
      if (!progressEvent.lengthComputable) return;
      const { loaded, total } = progressEvent;
      console.log('upload progress', (loaded / total) * 100);
    };

    submitAhcReimbursementRequest(data, onUploadProgress, authToken)
      .then(() => {
        setShowMessageModal(true);
        setShowInvoiceModal(false);
        setInvoiceFiles([]);
        setSelectedPatient(null);
        hideModal();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBooking(false);
      });
  };

  const bookPackage = () => {
    logEvent('Book Now Clicked', {
      packageId: packageDetails?.packageId,
      type: 'upsell',
    });
    startUpsellBookingFlow();
  };

  const getCartId = () => {
    if (bookCashlessAhcRef.current) return;
    bookCashlessAhcRef.current = true;
    setBooking(true);
    getLabTestsCart(authToken)
      .then((res) => {
        const { cartId: id } = res;
        setCartId(id);
        return fetchPatients(id);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        bookCashlessAhcRef.current = false;
        setBooking(false);
      });
  };

  const openAddNewPatientModal = () => {
    hideModal();
    setAddNewPatientModal(true);
  };

  const handleSaveNewPatient = () => {
    const patientDetails = {
      name: userName,
      age: userAge,
      phone: userContact,
      gender: userGender,
    };
    saveNewPatientService(patientDetails, authToken)
      .then(() => {
        fetchPatients(cartId);
        hideModal();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const exitPackageDetailsToHome = useCallback(() => {
    const added = addedCartItemRef.current;
    const cId = cartIdRef.current;
    if (added && cId) {
      removeLabTestRecommended(added, cId, authToken, true);
    }
    dismissNativeWebViewOrNavigateHome(history);
  }, [authToken, history]);

  useEffect(() => {
    const unblock = history.block((nextLocation, action) => {
      if (action !== 'POP') return true;
      if (upsellModalOpenRef.current) {
        setShowPatientModal(false);
        setShowPatients(false);
        setAddNewPatientModal(false);
        setShowMessageModal(false);
        setShowInvoiceModal(false);
        setShowInvoiceModalTransition(false);
        setSelectedPatient(null);
        setPartnerListLoaded(false);
        setPartners([]);
        setInvoiceFiles([]);
        setShowDateModal(false);
        setReimbursementProcess(false);
        setShowTestTypeModal(false);
        return false;
      }
      if (loadingRef.current) return true;
      const added = addedCartItemRef.current;
      const cId = cartIdRef.current;
      if (added && cId) {
        removeLabTestRecommended(added, cId, authToken, true);
      }
      queueMicrotask(() => {
        unblock();
        dismissNativeWebViewOrNavigateHome(history);
      });
      return false;
    });
    return () => unblock();
  }, [authToken, history]);

  useEffect(() => {
    window.document.title = 'Book Your Cashless Health Checkup';
    window.gtag('event', 'screen_view', { screen_name: 'AHC Package Screen' });
    if (!packageIdFromNavOrQuery) {
      setLoading(false);
      history.replace('/home');
      return;
    }
    setSelectedPackage(packageIdFromNavOrQuery);
    if (!cartIdFromNavOrQuery) {
      getCartId();
    } else {
      fetchPatients(cartIdFromNavOrQuery);
    }
    if (autoBookFromNavOrQuery) {
      startUpsellBookingFlow();
    }
    getPackageLeadsDetails(authToken, packageIdFromNavOrQuery)
      .then((res) => {
        setPackageDetails(res?.packageDetails && res.packageDetails[0]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const precautionsRender = (ele, idx) => (
    <>
      <div
        className="flex flex-row items-start"
        style={
          idx === packageDetails.precautions.length - 1
            ? { border: '0px' }
            : { borderLeft: '0.75px dashed #E3E3E3' }
        }
        key={idx}
      >
        <div
          className="bg-primary rounded-12 p-6px"
          style={{ marginLeft: '-7.5px' }}
        >
          <div
            className="bg-textbox rounded-12"
            style={{ padding: '1.5px' }}
          ></div>
        </div>
        <p
          className="text-body-s font-regular text-txtlight ml-12px mt-2px"
          style={
            idx === packageDetails.precautions.length - 1
              ? { marginBottom: '0px' }
              : { marginBottom: '16px' }
          }
          key={idx}
        >
          {ele}
        </p>
      </div>
    </>
  );

  const renderPatient = (ele) => (
    <div
      className="flex flex-row justify-between items-center rounded-12 bg-txtsecondary-shades4 bg-opacity-50 mb-20px py-24px pl-16px pr-20px"
      key={ele.patientId}
    >
      <div
        className="flex flex-1 flex-row items-center"
        onClick={() => handleSelectPatient(ele)}
      >
        <div
          className="bg-txtsecondary-shades7 rounded-full"
          style={{ width: '22px', height: '22px' }}
        ></div>
        <div className="txt-black-600-12 pl-12px flex flex-col">
          <span>{ele.name}</span>
          <span>
            {ele.age},{ele.gender}
          </span>
          {ele.phone !== null &&
            ele.phone !== undefined &&
            ele.phone.toString() !== '0' && (
              <span className="txt-grey-10">{ele.phone}</span>
            )}
        </div>
      </div>
    </div>
  );

  return (
    <div
      className="overflow-auto w-full"
      style={{ WebkitTapHighlightColor: 'transparent' }}
    >
      {loading ? (
        <div className="p-20 center h-full">
          <LoadingComponent />
        </div>
      ) : (
        <div className="mb-100px">
          <AHCHead2>
            {typeof window.Android === 'undefined' &&
              !window.ReactNativeWebView && (
                <Header
                  title={'Package Details'}
                  noBg={true}
                  onTap={exitPackageDetailsToHome}
                />
              )}
            <div className="flex items-center justify-between pl-20px">
              <div className="flex flex-col">
                <div>
                  <PackageName>{packageDetails.packageName}</PackageName>
                </div>
                <div>
                  <div className="text-primary text-body-l font-bold italic pt-16px">
                    70% Off
                  </div>
                </div>
                <div className="flex items-center pt-8px gap-8px">
                  <div
                    className="text-txtsecondary font-medium text-title-m2"
                    style={
                      packageDetails.offer_price
                        ? { textDecoration: 'line-through' }
                        : {}
                    }
                  >
                    ₹ {packageDetails.mrp}
                  </div>
                  {packageDetails.offer_price && (
                    <DiscountPill>₹ {packageDetails.offer_price}</DiscountPill>
                  )}
                </div>
              </div>
              <SideImageContainer src={HeaderImage} alt="image" />
            </div>
          </AHCHead2>
          <div className="flex items-center justify-center mt-18px gap-14px">
            <img src={Prize} alt="Prize" />
            <div>
              <div
                className="font-bolder text-title-l"
                style={{ color: '#FF626F' }}
              >
                Accredited Diagnostic Labs
              </div>
              <div className="">Skip the guesses, get 100% accuracy</div>
            </div>
          </div>
          <div className="flex items-center justify-center pt-32px gap-16px">
            {InfoSection?.map((ele) => (
              <div
                key={ele?.id}
                className="flex flex-col items-center gap-4px border border-primary rounded-12 px-20px py-12px"
              >
                <img src={ele?.image} alt={ele.text} />
                <div className="text-body-s font-medium text-txtlight">
                  {ele?.text}
                </div>
              </div>
            ))}
          </div>
          {packageDetails && (
            <div className="p-20px">
              <div className="mb-24px">
                <p className="text-body-l font-semibold text-txtlight mb-12px">
                  Why to book this package ?
                </p>
                <p
                  className="text-body-s text-txtlight font-regular"
                  style={{ color: '#767787' }}
                >
                  {packageDetails.reasonForBooking}
                </p>
              </div>
              <div className="mb-24px">
                <p className="text-body-l font-semibold text-txtlight mb-16px">
                  When to book this package ?
                </p>
                <p
                  className="text-body-s text-txtlight font-regular"
                  style={{ color: '#767787' }}
                >
                  {packageDetails.whenToBook}
                </p>
              </div>
              <div className="mb-24px">
                <p className="text-body-l font-semibold text-txtlight mb-12px">
                  Precautions
                </p>
                <p
                  className="text-body-s text-txtlight font-regular"
                  style={{
                    color: '#EB6138',
                    background: '#FFF9F7',
                    padding: '12px',
                    borderRadius: '8px',
                  }}
                >
                  {packageDetails.precautions &&
                  Array.isArray(packageDetails.precautions)
                    ? packageDetails.precautions.map((ele, idx) =>
                        precautionsRender(ele, idx)
                      )
                    : packageDetails.precautions}
                </p>
              </div>
              <div className="mb-24px">
                <div className="flex flex-row mb-12px items-center">
                  <p className="text-body-l font-semibold text-txtlight">
                    Tests
                  </p>
                </div>
                <div
                  className="max-h-200px overflow-y-auto bg-txtsecondary-shades4 rounded-12 p-16px pt-8px"
                  style={{ color: '#767787' }}
                >
                  {packageDetails.tests &&
                    packageDetails.tests.map((ele) => (
                      <p className="text-body-s mt-8px font-medium text-txtlight">
                        {ele.name}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          )}
          <FooterButton
            buttonText={booking ? 'Loading...' : 'Book Now'}
            onClick={bookPackage}
          />
        </div>
      )}
      {showPatientModal && (
        <Modal>
          <div className="modalContainer">
            <FlyInTransition
              in={showPatients}
              mountOnEnter
              unmountOnExit
              onExited={closeModal}
              appear
            >
              <div className="modalBody" ref={nodeRef}>
                <div className="modalHeader">
                  <div className="flex flex-row items-center">
                    <img src={profileIcon} alt="" />
                    <p className="ml-10px text-body-l text-txtlight-new font-semibold">
                      Select member to continue
                    </p>
                  </div>
                  <CloseContainer onTap={closeModal}>
                    <CloseIcon />
                  </CloseContainer>
                </div>
                <div className="modalDetails">
                  {patients.map(renderPatient)}
                  {showAddPatientButton && (
                    <div
                      className="flex flex-row items-center justify-center mt-24px"
                      onClick={openAddNewPatientModal}
                    >
                      <div className="bg-txtsecondary-shades7 p-6px bg-opacity-40 rounded-6">
                        <AddTextIcon />
                      </div>
                      <span className="text-body-l text-txtlight font-semibold pl-10px">
                        Add member
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </FlyInTransition>
          </div>
        </Modal>
      )}
      <UpsellBookingFlowModals ref={bookingFlowRef} />
      {addNewPatientModal && (
        <Modal>
          <div className="modalContainer" onClick={handleOutsideClick}>
            <FlyInTransition
              in={addNewPatientModal}
              mountOnEnter
              unmountOnExit
              onExited={hideModal}
              appear
            >
              <div className="modalBody" ref={nodeRef}>
                <div className="modalHeader">
                  <div className="flex flex-row items-center">
                    <img src={profileIcon} alt="" />
                    <p className="ml-10px text-body-l text-txtlight-new font-semibold">
                      Add Member
                    </p>
                  </div>
                  <CloseContainer onTap={hideModal}>
                    <CloseIcon />
                  </CloseContainer>
                </div>
                <div className="modalDetails">
                  <div>
                    <p className="text-body-s text-txtlight font-medium">
                      Full Name
                    </p>
                    <input
                      className="mt-8px new-address-input text-title-s font-semibold"
                      placeholder="Full Name"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  <div className="mt-24px">
                    <p className="text-body-s text-txtlight font-medium">Age</p>
                    <input
                      type="number"
                      className="mt-8px new-address-input text-title-s font-semibold"
                      placeholder="Age*"
                      value={userAge}
                      onChange={(e) => setUserAge(e.target.value)}
                    />
                  </div>
                  <div className="mt-24px">
                    <p className="text-body-s text-txtlight font-medium">
                      Gender
                    </p>
                    <div className="flex flex-row w-full justify-start mt-8px">
                      {['Male', 'Female', 'Other'].map((gender) => (
                        <span
                          key={gender}
                          className="text-center relative pt-8px pb-8px border border-txtsecondary-shades7 border-solid rounded-12 pr-24px pl-24px mr-24px"
                          onClick={() => setUserGender(gender)}
                          style={
                            userGender === gender
                              ? { borderColor: '#6C5DD3' }
                              : {}
                          }
                        >
                          <p
                            className="text-body-l font-regular"
                            style={
                              userGender === gender
                                ? { color: '#6C5DD3', fontWeight: '600' }
                                : { color: '#302E6B' }
                            }
                          >
                            {gender}
                          </p>
                          {userGender === gender && (
                            <span className="absolute -top-10px -right-10px">
                              <img src={checkedIcon} alt="tick" />
                            </span>
                          )}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="mt-24px">
                    <p className="text-body-s text-txtlight font-medium">
                      Contact Number
                    </p>
                    <input
                      type="number"
                      className="mt-8px new-address-input text-title-s font-semibold"
                      placeholder="contact*"
                      value={userContact}
                      onChange={(e) => setUserContact(e.target.value)}
                    />
                  </div>
                  <div className="mt-24px">
                    <div
                      className="pl-16px pr-16px mt-12px rounded-12 hover pt-12px pb-12px text-button-s font-semibold text-textbox text-center flex flex-row justify-center items-center"
                      style={{
                        background: '#6C5DD3',
                        backdropFilter: 'blur(4px)',
                        width: '100%',
                      }}
                      onClick={handleSaveNewPatient}
                    >
                      <span className="flex flex-row items-center">
                        <p className="mr-8px text-body-l font-semibold text-textbox">
                          Next
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </FlyInTransition>
          </div>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  insured: state.app.config.insured,
});

export default connect(mapStateToProps)(PackageDetails);
